module.exports = "<my-railway-display my-railway=\"$$railway.data.myRailway\"\n  my-wagons=\"$$wagon.data.myWagons\"\n  enable-buttons=\"true\"\n  enable-position=\"true\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-railway-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/railway/templates/details.html
// module id = 1519
// module chunks = 0